import React, { Component } from "react";
import Collapsible from "react-collapsible";
import HttpServices from "../../../utils/Http.services";
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../../utils/useful";
import { diagramComponents, diagramGroups } from "../../../variables/diagramFunctions";
import FormViewer from "../../FormViewer";
import LoaderButton from "../../LoaderButton";
import SidebarView from "../../SidebarView";
import StagesManager from "../../StagesManager";
import TableViewer from "../../TableViewer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import FixedView from "../../FixedView";
import ReactLoaderSpinner from "react-loader-spinner";

class DiagramAddThirdParty extends Component {

    state = {
        trigger: true,
        action: true,
        fixed: true,
        closedGroups: {},
        // parts: [
        //     { label: '{{lang}}Variables', key: 'variables', icon: '/assets/icons/useful/text.svg' },
        // ],
        selectedParent: {},
        thirdparties: [
            { name: 'Gmail', _id: 'gmail', icon: '/thirdparties/gmail.webp' },
            { name: 'Paypal', _id: 'paypal', icon: '/thirdparties/paypal.jpg' },
            { name: 'Stripe', _id: 'stripe', icon: '/thirdparties/stripe.png' },

        ],

    }

    componentDidMount() {
        this.getMyApplets()

    }

    openFirstView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {
            if (this.state.fixed == true) {
                this.firstView.hideView()
            } else {
                this.firstView.showView()
                setTimeout(() => {
                    this.setState({ showFixed: true })
                }, 100);
            }
        })
    }


    getMyApplets = () => {
        let data = {}
        data.username = this.props.variables.user?.username
        this.setState({ isLoadingData: true })
        HttpServices.request('getHubByUsername', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            fetchResult.applets.forEach(element => {
                element.isParent = true
            });
            this.setState({ applets: fetchResult.applets }, () => {
                // this.setApplet(this.state.applets[0])
            })
            this.setState({ isLoadingData: false }, () => {

            })
        })
    }

    setApplet = (item) => {
        this.chooseParent(item)
        this.setState({ currentSelect: item.applet }, () => {
        })
    }

    selectApplet = (item) => {

        this.setState({ currentApplet: item }, () => {
        })
        this.stageManager.changeStage('')
    }

    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    showChildsList = (parent) => {
        if (parent) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: parent })
        } else {
            this.subSidebarView.closeSidebar()
            setTimeout(() => {
                this.setState({ selectedParent: parent })
            }, 500);
        }
    }

    showApplet = (applet) => {
        if (applet) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: applet })
        }
    }

    openVariables = () => {
        this.varSidebarView.open()
        this.openFirstView()
    }

    addNewVariables = () => {
        this.stageManager.changeStage('addNew')
    }

    backStage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'DiagramEditor') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    saveVariables = () => {
        let data = this.form.getForm() ?? {}
        data.applet = this.props.variables.appletId
        data.appletHub = this.props.variables.appletHub._id
        if (data.type) {
            HttpServices.request('postVariables', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                let variablesList = this.props.variablesList ?? []
                variablesList.push(fetchResult.info)
                this.setData('variablesList', variablesList, 'DiagramEditor', () => {
                    this.backStage('main')
                })
            })
        }
    }

    onTouchMove = (e, prop) => {
        let x
        let y
        if (e.touches) {
            x = e.touches[0].clientX
            y = e.touches[0].clientY
        }
        let id = prop.key
        if (this.state.dragId !== id && this.dragOverId != id) {
            this.setState({ dragId: id })
        }
        let ghost = document.getElementById('drag-ghost')
        if (ghost) {
            ghost.style.top = (y - Number(ghost.style.height.replace('px', '')) / 2) + 'px'
            ghost.style.left = (x - Number(ghost.style.width.replace('px', '')) / 2) + 'px'
        }
    }

    onTouchEnd = (e) => {
        this.setState({ dragId: null })
        this.props.onDrop(e)
    }

    onClick = (cprop) => {
        if (cprop.isParent) {
            this.showChildsList(cprop)
        } else {
            if (!this.props.draggable) {
                this.props.onClick(cprop, this.state.selectedParent?.type)
            }
        }
    }

    chooseParent = (data) => {
        let item = data
        if (typeof item != 'object') {
            item = { features: ['flowControl'], default: true }
        }
        if (this.state.selectedParent?._id != item?.applet?._id || (!this.state.selectedParent?._id && this.state.selectedParent?.type != item.features[0])) {
            let selectedParent = { type: item.features[0], _id: item?.applet?._id ?? this.props.variables.appletId, default: item.default }
            this.setState({ selectedParent })
        } else {
            this.setState({ selectedParent: null })
        }
    }

    onDragStart = (e, formItem) => {

        this.props.onDragStart(e, formItem, 'function', this.state.selectedParent)

        setTimeout(() => {
            this.firstView.hideView()
        }, 100);
    }

    selectThirdParty = (item) => {
        this.setState({ selectedThirdparty: item })
        this.stageManager.changeStage('units')
    }

    render() {
        // if (this.props.showElements) {
        return (

            <div  >

                <StagesManager ref={el => this.stageManager = el} fast={true}>

                    <div stageName="init" stage={0}>
                        <div className="px-2 pt-2 pb-1" style={{ borderBottom: '1px solid #eee' }}>
                            <p className="text-small text-bold ">{checkTranslation("Third Parties")}</p>
                            {/* <p className="text-smaller text-semibold mb-1">{translate("Frames of this applet can be used in the automation")}</p> */}

                        </div>

                        <div className='px-1 flexcc pt-1 mb-1' style={{}}>
                            <div className='w-100 flexc ' style={{ borderBottom: "0px solid #eee", height: '30px', cursor: 'auto' }}>
                                {/* <p className='px-2 font-size-13 main-c2'>Drag an element</p> */}
                                <input placeholder={translate('Search')} className='py-1 px-2 br-5 w-100 text-semibold' style={{ backgroundColor: '#F2F2F2', border: '1px solid #F2F2F7' }} />
                            </div>
                        </div>

                        <div className="px-1">
                            {this.state.thirdparties?.map((item, index) => {
                                if (item) {
                                    return (
                                        <button className="px-1 py-2 w-100 br-4 my-1 flexcb transition-all" key={item._id} onClick={() => { this.selectThirdParty(item) }} style={{ borderBottom: '1px solid #f6f6f6' }}>
                                            <div className=" flexc w-100 text-smaller">
                                                <img draggable={false} src={item.icon} className='' width={22} />
                                                <div className="mld-3 text-start" draggable={false} style={{ whiteSpace: 'nowrap' }}>
                                                    <p draggable={false} className="text-semibold font-size-13">{checkTranslation(item.name)}</p>
                                                    {/* <p className="color-gray-3 font-size-10"  >{item.features[0]}</p> */}
                                                </div>
                                            </div>
                                            <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                        </button>
                                    )
                                }
                            })}
                        </div>
                    </div>



                    <div stage={1} stageName="units">
                        <div className="top-0 w-100" style={{ borderBottom: "1px solid #eee", position: 'sticky', background: '#fff', }}>
                            <div className="px-2 pt-2 pb-1 flexc " style={{ borderBottom: '0px solid #eee', }}>
                                <button className="flexcc" onClick={()=>this.stageManager.changeStage('init')}>
                                    <img draggable={false} src={'/assets/icons/back-white.svg'} className='invert' width={22} />
                                </button>
                                <img draggable={false} src={this.state.selectedThirdparty?.icon} className='mld-0 ' width={22} />
                                <p className="text-small text-bold mld-2">{checkTranslation(this.state.selectedThirdparty?.name)}</p>
                            </div>

                            <div className="flexc px-2 pt-0 mb-1 " style={{ background: '#fff', borderRadius: '0px 8px 0px 0px', zIndex: 1, }}>
                                <button>
                                    <p className="py-1 px-1 font-size-12 text-semibold" style={{ color: '#007aff', borderBottom: '2px solid #007aff' }} onClick={() => this.setState({ trigger: !this.state.trigger })}>All</p>
                                </button>
                                <button>
                                    <p className="py-1 px-1 font-size-12 text-semibold" style={{ color: '#202020', borderBottom: '2px solid #fff' }} onClick={() => this.setState({ trigger: !this.state.trigger })}>Operators</p>
                                </button>
                                <button>
                                    <p className="py-1 px-1 font-size-12 text-semibold" style={{ color: '#202020', borderBottom: '2px solid #fff' }} onClick={() => this.setState({ trigger: !this.state.trigger })}>Triggers</p>
                                </button>
                                <button>
                                    <p className="py-1 px-1 font-size-12 text-semibold" style={{ color: '#202020', borderBottom: '2px solid #fff' }} onClick={() => this.setState({ trigger: !this.state.trigger })}>Actions</p>
                                </button>
                            </div>
                        </div>

                        <div className='px-2 flexcc pt-1 mb-1' style={{}}>
                            <div className='w-100 flexc ' style={{ borderBottom: "0px solid #eee", height: '30px', cursor: 'auto' }}>
                                {/* <p className='px-2 font-size-13 main-c2'>Drag an element</p> */}
                                <input placeholder={translate('Search')} className='py-1 px-2 br-5 w-100 text-semibold' style={{ backgroundColor: '#F2F2F2', border: '1px solid #F2F2F7' }} />
                            </div>
                        </div>



                        <div className=" sc-gray2 w-100 px-1" style={{ height: '254px' }}>
                            <div style={{ borderBottom: '0px solid #eeeeeecc' }}>


                                <div >
                                    {Object.values(diagramComponents).map((formItem, index) => {
                                        if (true) {
                                            let color = 'rgb(75,126,255)'
                                            if (formItem.group == 'operator') {
                                                color = '#00c746'
                                            }
                                            if (formItem.group == 'trigger') {
                                                color = '#ffb700'
                                            }
                                            return (
                                                <>
                                                    <div className="py-2 w-100 flexcb br-10" style={{ cursor: 'move' }} key={formItem.type}  onTouchStart={(e) => this.props.onDragStart(e, formItem)} onDragStart={(e) => this.props.onDragStart(e, formItem)} onTouchMove={(e) => this.props.onTouchMove(e, formItem)} onTouchEnd={(e) => this.props.onTouchEnd(e)} draggable={!formItem.isParent}>
                                                        <div className="flexc">
                                                            <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 prd-1' draggable={false} />
                                                            <div key={index} className=" flexc w-100 text-smaller " style={{}}>
                                                                <img draggable={false} src={formItem.icon} height={18} style={{ opacity: '1' }} />
                                                                <p draggable={false} className="mld-2 text-semibold">{checkTranslation(formItem.name ?? formItem.title)}</p>
                                                            </div>
                                                        </div>
                                                        {formItem.isParent && (
                                                            <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                        )}
                                                        <div className="br-4 px-2 py-1 mrd-2 text-semibold text-capitalize" style={{ background: '#f6f6f6', color }}>
                                                            <p className="text-smallest">{formItem.group}</p>
                                                        </div>
                                                    </div>
                                                </>
                                            );
                                        }
                                    })}
                                </div>
                            </div>

                        </div>

                    </div>

                </StagesManager>




            </div >
        )

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DiagramAddThirdParty);